import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "camera"
  static targets = ["dropzone"]

  connect() {
    super.connect()

    if (this.enabled) {
      this.#interceptDropzoneClick()
      this.notifyBridgeOfConnect()
    }
  }

  notifyBridgeOfConnect() {
    this.send("connect", {})
  }

  #interceptDropzoneClick() {
    if (!this.hasDropzoneTarget) return

    // Find the dropzone element and intercept clicks
    const dropzoneElement = this.dropzoneTarget

    // Intercept click on dropzone area
    dropzoneElement.addEventListener("click", (event) => {
      // Prevent default dropzone file input from opening
      event.preventDefault()
      event.stopPropagation()
      this.#capturePhoto()
    }, true)

    // Also intercept the file input directly
    const fileInput = dropzoneElement.querySelector('input[type="file"]')
    if (fileInput) {
      fileInput.addEventListener("click", (event) => {
        event.preventDefault()
        event.stopPropagation()
        this.#capturePhoto()
      }, true)
    }
  }

  #capturePhoto() {
    this.send("capture", {}, (message) => {
      const data = message?.data
      if (data && data.base64) {
        this.#addFileToDropzone(data.base64, data.filename || "photo.jpg")
      }
    })
  }

  #addFileToDropzone(base64Data, filename) {
    console.log("[Camera] Adding file to dropzone:", filename)

    // Get the Dropzone instance from the controller
    const dropzoneElement = this.dropzoneTarget
    console.log("[Camera] Dropzone element:", dropzoneElement)

    const dropzoneController = this.application.getControllerForElementAndIdentifier(
      dropzoneElement,
      "dropzone"
    )
    console.log("[Camera] Dropzone controller:", dropzoneController)

    if (!dropzoneController || !dropzoneController.dropZone) {
      console.error("[Camera] Dropzone controller not found")
      return
    }

    const dropzone = dropzoneController.dropZone
    console.log("[Camera] Dropzone instance:", dropzone)

    // Convert base64 to File
    const file = this.#base64ToFile(base64Data, filename)
    console.log("[Camera] Created file:", file.name, file.size, "bytes")

    // Add file to Dropzone - this triggers preview and upload
    dropzone.addFile(file)
    console.log("[Camera] File added to dropzone")
  }

  #base64ToFile(base64Data, filename) {
    const base64 = base64Data.includes(',') ? base64Data.split(',')[1] : base64Data
    const mimeType = "image/jpeg"

    const byteCharacters = atob(base64)
    const byteNumbers = new Array(byteCharacters.length)
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i)
    }
    const byteArray = new Uint8Array(byteNumbers)
    const blob = new Blob([byteArray], { type: mimeType })

    return new File([blob], filename, { type: mimeType })
  }
}
